
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/musik",
      function () {
        return require("private-next-pages/musik/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/musik"])
      });
    }
  